import { useId } from 'react';

import { AnglerfishCostume } from './AnglerfishCostume';
import type { OccasionId } from './occasions';

import styles from './ThemeToggle.module.scss';

/**
 * The thumb of the theme switch: an anglerfish whose lure lights up in the dark theme.
 * Colours come from the stylesheet, keyed on the switch's `data-state`. On an occasion it
 * wears that occasion's costume.
 */
export function AnglerfishIcon({ occasion = null }: { occasion?: OccasionId | null }) {
    // Two switches can be on screen (header and mobile row), so each needs its own gradient.
    const glowId = `anglerfish-glow-${useId().replace(/:/g, '')}`;

    return (
        <svg className={styles.anglerfish} viewBox="0 0 24 24" aria-hidden focusable="false">
            <defs>
                <radialGradient id={glowId}>
                    <stop offset="0" className={styles.glowCore} />
                    <stop offset="0.45" className={styles.glowMid} />
                    <stop offset="1" className={styles.glowEdge} />
                </radialGradient>
            </defs>
            <path className={styles.fishBody} d="M4.6 13 L1.2 9.6 Q1.9 13 1.2 16.4 Z" />
            <path
                className={styles.fishBody}
                d="M4.4 13 C4.4 8.6 8.3 6.3 12.6 6.7 C16.4 7.1 19.3 9.4 19.9 12 L16.6 13.3 L19.9 14.9 C18.9 17.9 15.6 19.6 12 19.2 C7.7 18.8 4.4 16.6 4.4 13 Z"
            />
            <path
                className={styles.fishTeeth}
                d="M17.25 12.75 L18.05 12.45 L17.6 13.55 Z M17.25 14.05 L18.05 14.35 L17.6 13.25 Z"
            />
            <circle className={styles.fishEye} cx="14.6" cy="10.4" r="1.15" />
            <path className={styles.fishRod} d="M11.6 7 C11.9 3.4 16.4 2.1 19.2 4.3" />
            {occasion && <AnglerfishCostume occasion={occasion} />}
            <circle className={styles.glow} cx="19.9" cy="5.1" r="6.2" fill={`url(#${glowId})`} />
            <circle className={styles.lure} cx="19.9" cy="5.1" r="1.55" />
        </svg>
    );
}
